import { createTypes } from "reduxsauce";

export default createTypes(
    `
        GET_MY_BOOKINGS_INITIATED
        REFRESH_MY_BOOKINGS_INITIATED
        GET_MY_BOOKINGS_SUCCESS
        GET_MY_BOOKINGS_FAILURE
        GET_MY_PAYMENT_SUMMARY

        BOOKING_CANCELLATION_INITIATED
        BOOKING_CANCELLATION_SUCCESS
        BOOKING_CANCELLATION_FAILURE

        UPDATE_SELECTED_CAR

        PAYMENT_SUMMARY_LOADING

        UPDATE_PAYMENT_SUMMARY_CACHE_DATA
        RESET_PAYMENT_SUMMARY_CACHE_DATA
        
        PAYMENT_SUMMARY_STATUS_SUCCESS
        PAYMENT_SUMMARY_STATUS_LOADING
        PAYMENT_SUMMARY_STATUS_FAILED

        UPDATE_MY_PAYMENT_SUMMARY_STATUS
        UPDATE_PAYMENT_SUMMARY_STATUS_LOADING
        
        RESET_PAYMENT_SUMMARY_DATA
        GET_PAYMENT_SUMMARY_CMS_CONFIG_SUCCESS
        GET_PAYMENT_SUMMARY_CMS_CONFIG_FAILURE
        GET_PAYMENT_SUMMARY_CMS_CONFIG_INITIATED

`,
    {
        prefix: "mybookings/"
    }
);
